<template>
  <div>
    <b-overlay :show="formShow" rounded="true" :fixed="true" no-fade>
      <b-card>
        <b-row>
          <table class="table table-sm">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="bg-primary text-white align-middle"
                  style="font-size: 1.2em;"
                >
                  Add New Review
                </th>
                <th
                  scope="col"
                  class="bg-primary text-white d-flex justify-content-end align-middle"
                >
                  <b-button
                    type="submit"
                    @click.prevent="formSubmitted"
                    variant="warning"
                    class="float-right animate__animated animate__fadeIn"
                  >
                    Save Review
                  </b-button>
                </th>
              </tr>
            </thead>
          </table>
        </b-row>

        <!-- Breadcrumb Navigation -->
        <b-breadcrumb class="bg-transparent px-0 py-2 mb-3">
          <b-breadcrumb-item :to="{ name: 'review-list' }">
            <feather-icon icon="ListIcon" size="16" class="mr-1" />
            Review List
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            <feather-icon icon="PlusIcon" size="16" class="mr-1" />
            Add Review
          </b-breadcrumb-item>
        </b-breadcrumb>

        <validation-observer ref="reviewRules">
          <b-form>
            <!-- <b-row class="d-flex justify-content-end mt-1">
            
          
          </b-row> -->
            <b-row class="mt-1">
              <!-- Person Selection -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Reviewee" label-for="person">
                  <validation-provider
                    name="Reviewee"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="person"
                      v-model="selectedPerson"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="fullName"
                      :reduce="(val) => val"
                      :clearable="false"
                      :options="observers"
                      @option:selected="selectedPersonHandler"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- First Name -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group>
                  <label for="firstName">First Name</label>
                  <validation-provider
                    name="First Name"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-input
                      id="firstName"
                      type="text"
                      v-model="reviewData.firstName"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Last Surname -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Last Name" label-for="lastName">
                  <validation-provider
                    name="Last Name"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-input
                      id="lastName"
                      type="text"
                      v-model="reviewData.lastName"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Email -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Email" label-for="email">
                  <validation-provider
                    name="Email"
                    #default="{ errors }"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      type="text"
                      v-model="reviewData.emailAdress"
                      disabled
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Event -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label="Questionnaire"
                  label-for="event"
                  id="eventLabel"
                >
                  <validation-provider
                    name="event"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="event"
                      v-model="reviewData.event"
                      :options="eventTypes"
                      :reduce="(val) => val"
                      :filterable="true"
                      @option:selected="selectedEvents"
                      label="title"
                      :clearable="false"
                      input-id="event"
                    >
                      <template #option="option">
                        <div
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px;"
                          :title="option.title"
                        >
                          {{ option.title }}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;"
                          :title="option.title"
                        >
                          {{ option.title }}
                        </div>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        {{
                          selectedPerson
                            ? "This is the no options slot "
                            : "Please select a Reviewee"
                        }}
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Observer -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Reviewer" label-for="observer">
                  <validation-provider
                    name="Reviewer"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      id="observer"
                      v-model="reviewData.observer"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="fullName"
                      :reduce="(val) => val"
                      :clearable="false"
                      :options="observers"
                      @option:selected="selectedObserver(reviewData.observer)"
                      :disabled="!$Can('add_review')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Task Selection (Read-only, from Questionnaire) -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="reviewData.selectedTask"
              >
                <b-form-group label="Assigned Task" label-for="task-display">
                  <b-input-group>
                    <b-form-input
                      id="task-display"
                      :value="
                        reviewData.selectedTask
                          ? reviewData.selectedTask.title
                          : 'No task assigned'
                      "
                      readonly
                      style="background-color: #f8f9fa;"
                    />
                    <b-input-group-append>
                      <b-button variant="outline-secondary" disabled>
                        <feather-icon icon="LockIcon" size="14" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-muted"
                    >Task is configured in the Questionnaire settings</small
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group>
                  <label for="surveyDate">Review Date</label>
                  <validation-provider
                    name="Review Date"
                    #default="{ errors }"
                    rules="required"
                  >
                    <flat-pickr
                      id="surveyDate"
                      class="form-control"
                      :config="{ dateFormat: 'd/m/Y' }"
                      placeholder="DD/MM/YYYY"
                      v-model="reviewData.surveyDate"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- AM/PM Selection - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="reviewData.selectedTask"
              >
                <b-form-group>
                  <label>Working Time</label>
                  <div class="d-flex">
                    <b-button
                      :variant="
                        reviewData.workingTime === 'am'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="setWorkingTime('am')"
                      class="mr-2"
                      style="border-radius: 50px; min-width: 60px;"
                    >
                      AM
                    </b-button>
                    <b-button
                      :variant="
                        reviewData.workingTime === 'pm'
                          ? 'primary'
                          : 'outline-primary'
                      "
                      @click="setWorkingTime('pm')"
                      style="border-radius: 50px; min-width: 60px;"
                    >
                      PM
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>

              <!-- Start Time - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="reviewData.selectedTask"
              >
                <b-form-group>
                  <label for="startTime">Start Time</label>
                  <validation-provider
                    name="Start Time"
                    #default="{ errors }"
                    :rules="reviewData.selectedTask ? 'required' : ''"
                  >
                    <flat-pickr
                      id="startTime"
                      v-model="reviewData.startTime"
                      class="form-control"
                      :config="startTimeConfig"
                      @on-change="onStartTimeChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- End Time - Show only when task is selected -->
              <b-col
                cols="12"
                sm="6"
                md="4"
                xl="3"
                v-if="reviewData.selectedTask"
              >
                <b-form-group>
                  <label for="endTime">End Time</label>
                  <validation-provider
                    name="End Time"
                    #default="{ errors }"
                    :rules="reviewData.selectedTask ? 'required' : ''"
                  >
                    <flat-pickr
                      id="endTime"
                      v-model="reviewData.endTime"
                      class="form-control"
                      :config="endTimeConfig"
                      @on-change="onEndTimeChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Follow-up info alert -->
              <b-col cols="12" v-if="reviewData.event && reviewData.event.follow_up_config && reviewData.event.follow_up_config.enabled">
                <b-alert show variant="info" class="mb-1">
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  Follow-up reviews are enabled for this questionnaire. Completing this initial review will automatically schedule follow-ups.
                </b-alert>
              </b-col>

              <b-row class="mt-2" v-if="groups.length > 0">
                <b-col
                  cols="12"
                  xl="12"
                  md="12"
                  sm="12"
                  style="margin-bottom: 1rem;"
                >
                  <!-- Display all groups and questions without tabs -->
                  <div
                    v-for="(group, groupIndex) in filteredGroups"
                    :key="group.id"
                    class="group-section"
                    :class="{ 'mt-4': groupIndex > 0 }"
                  >
                    <b-col cols="12" xl="12" md="12" sm="12">
                      <h4
                        class="group-title mb-3"
                        style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem;"
                      >
                        {{ group.groupName }}
                      </h4>
                      <b-table
                        hover
                        responsive
                        fixed
                        head-variant="dark"
                        :items="group.questions"
                        class="position-relative mb-4"
                        :fields="fields"
                        show-empty
                        empty-text="No questions found"
                      >
                        <template #cell(questions)="data">
                          <div>
                            <div class="question-content">
                              <span
                                >{{ data.item.title }}
                                <small
                                  v-if="
                                    data.item.status === 'A' &&
                                      data.item.maxScore
                                  "
                                  class="text-muted"
                                >
                                  ( Max Score: {{ data.item.maxScore }} )
                                </small>
                                <small
                                  v-if="
                                    data.item.status === 'A' &&
                                      data.item.passingScore !== null &&
                                      data.item.passingScore !== undefined
                                  "
                                  class="text-muted"
                                >
                                  ( Passing Score :
                                  {{ data.item.passingScore || 0 }} )
                                </small>
                              </span>
                            </div>
                            <small
                              v-if="data.item.subtitle"
                              class="d-block text-muted mt-1"
                              style="font-style: italic;"
                            >
                              {{ data.item.subtitle }}
                            </small>
                          </div>
                        </template>

                        <template #cell(answer)="data">
                          <validation-provider
                            :name="data.item.title"
                            #default="{ errors }"
                          >
                            <!-- status A Answer type -->
                            <v-select
                              v-if="data.item.status === 'A'"
                              :id="data.item.title"
                              :options="generateScoreRange(data.item)"
                              :reduce="(val) => val"
                              :filterable="false"
                              :clearable="false"
                              v-model="data.item.commentAnswer"
                              :input-id="data.item.title"
                              @option:selected="selectedGroupValue(data.item)"
                              @input="takeAQuestionAnswer"
                            />
                            <!-- status B Comment type -->
                            <span>
                              <b-form-textarea
                                v-if="data.item.status != 'A'"
                                :id="data.item.title"
                                placeholder="Comment here"
                                rows="2"
                                debounce="500"
                                no-resize
                                v-model="data.item.commentAnswer"
                                @input="takeAQuestionAnswer"
                                @change="selectedGroupValue(data.item)"
                                style="width:100%"
                              ></b-form-textarea>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </span>
                          </validation-provider>
                        </template>
                      </b-table>
                    </b-col>
                  </div>
                  <div class="group-section" v-if="groups.length > 0 && !isPmdsReview">
                    <b-col cols="12" class="bodyRow" style="padding: 0.2rem 0;">
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <h4
                          class="group-title mb-0"
                          style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem; flex-grow: 1;"
                        >
                          General Comment
                        </h4>
                      </div>
                    </b-col>
                    <b-col cols="12" xl="12">
                      <b-form-textarea
                        id="generalComment"
                        v-show="$Can('add_review')"
                        v-model="reviewData.generalComment"
                        placeholder="REVIEWER'S NOTES/RECOMMENDATIONS"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </b-col>
                  </div>
                </b-col>
              </b-row>

              <b-col cols="12" xl="12" md="12" class="text-center mt-2" v-else>
                <h3>
                  Please Choose Questionnaire Type
                </h3>
              </b-col>
              <!-- <b-col cols="12" class="mb-5">
              <b-button
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="mr-1 float-right"
              >
                Save
              </b-button>
            </b-col> -->
            </b-row>
          </b-form>
        </validation-observer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink,
  VBModal,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";

import store from "@/store";
import reviewStoreModule from "./reviewStoreModule";
import ImageCropper from "@core/components/image-cropper/ImageCropper.vue";
import { required, alphaNum, email } from "@validations";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import moment from "moment";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axiosIns from "@/libs/axios";
import _ from "lodash";
import { t } from "@/@core/libs/i18n/utils";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "animate.css";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import {
  INVALID_TIME_RANGE_MESSAGE,
  isValidTimeRange,
  bumpEndTime,
  apiErrorMessage,
} from "@/libs/timeRange";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,

    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    FeatherIcon,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const REVIEW_APP_STORE_MODULE_NAME = "review";
    // Register module
    if (!store.hasModule(REVIEW_APP_STORE_MODULE_NAME))
      store.registerModule(REVIEW_APP_STORE_MODULE_NAME, reviewStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REVIEW_APP_STORE_MODULE_NAME))
        store.unregisterModule(REVIEW_APP_STORE_MODULE_NAME);
    });
  },

  data: function() {
    var reviewData = {
      surveyDate: null,
      firstName: null,
      lastName: null,
      emailAdress: null,
      observer: null,
      reviewee: null, // Reviewee field'ını ekliyoruz
      event: null,
      generalComment: null,
      questionAnswer: [],
      selectedTask: null,
      startTime: null,
      endTime: null,
      workingTime: "am",
    };

    const statusOptions = [
      { label: "Active", value: "active" },
      { label: "Passive", value: "passive" },
    ];

    return {
      reviewData: reviewData,
      baseURL: store.state.app.baseURL,
      userData: JSON.parse(localStorage.getItem("userData")),
      required,
      alphaNum,
      email,
      observers: [],
      selectedPerson: null,
      formShow: false,
      groups: [],
      allGroupsData: [],
      allQuestionnaires: [],
      ans: null,
      eventTypes: [],
      startTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 8,
        defaultMinute: 0,
      },
      endTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 5,
        defaultHour: 12,
        defaultMinute: 0,
      },
      fields: [
        {
          key: "questions",
          label: "questions",
          thStyle: { width: "70%" },
        },
        {
          key: "answer",
          label: "answer",
          thStyle: { width: "30%" },
          thClass: "text-center",
          tdClass: "text-center ",
        },
      ],
    };
  },
  mounted() {
    this.userDetails();
    this.getQuestionnaires();
    this.getObservers();
    this.updateTimeConfigs("am");
  },

  created() {},

  computed: {
    filteredGroups() {
      // Initial reviews only show groups tagged as 'initial' (follow_up_months == null)
      return this.groups.filter(g => g.follow_up_months == null);
    },
    // PMDS questionnaires do not use the General Comment box
    isPmdsReview() {
      const title = this.reviewData?.event?.title || "";
      return title.toUpperCase().includes("PMDS");
    },
  },

  watch: {
    // 'reviewData.event': {
    //   handler: function(val, before) {
    //     console.log(val);
    //   },w
    // },
    // flatpickr's on-change fires before v-model updates, so watch the value itself
    "reviewData.startTime"() {
      this.onStartTimeChange();
    },
  },

  methods: {
    convertDateToBackend(date) {
      if (!date) return null;
      // Parse date from DD/MM/YYYY format and convert to MM-DD-YYYY for backend
      const parsedDate = moment(String(date), "DD/MM/YYYY", true);
      if (parsedDate.isValid()) {
        return parsedDate.format("MM-DD-YYYY");
      }
      // If parsing fails, return as is
      return date;
    },

    showQuestionAnswer(ans) {
      this.ans = ans;
    },
    takeAQuestionAnswer(ans) {
      this.ans = ans;
    },
    selectedGroupValue(val) {
      //   let findedGroup = this.allGroupsData.find((e) => e.id == val.groupId);
      this.reviewData.questionAnswer.forEach((question) => {
        if (question.questionId == Number(val.id)) {
          question.commentAnswer = this.ans;
        }
      });
    },
    selectedObserver(selectedObserver) {
      this.reviewData.observer = selectedObserver.fullName;
    },
    selectedEvents(event) {
      if (event) {
        this.reviewData.questionAnswer = [];

        // Auto-load task from questionnaire if available
        if (event.task) {
          this.reviewData.selectedTask = event.task;
          console.log("Auto-loaded task from questionnaire:", event.task);
        } else {
          this.reviewData.selectedTask = null;
          console.log("No task found in questionnaire");
        }

        event.groups.forEach((group) => {
          group.questions.forEach((question) => {
            question.commentAnswer =
              question.status === "A" ? "Not Observed" : null;
          });
        });

        this.groups = event.groups ? event.groups : [];
        this.groups.forEach((element) => {
          element.questions.forEach((q) => {
            let questionAnswer = {
              questionId: q.id,
              status: q.status,
              groupId: q.groupId,
              commentAnswer: q.status === "A" ? "Not Observed" : null,
              maxScore: q.maxScore,
              passingScore: q.passingScore,
            };
            this.reviewData.questionAnswer.push(questionAnswer);
          });
          element.questions.sort((a, b) => a.order - b.order);
        });
      }
    },
    getQuestionnaires() {
      this.formShow = true;
      store
        .dispatch("review/fetchQuestionnaires")
        .then((res) => {
          res.data.forEach((item) => {
            let obj = {
              id: item.id,
              title: item.title,
              status: item.status,
              groups: [],
              chartColour: item.chartColour,
              questions: [],
              task: item.task, // Add task to obj
            };
            if (item.groups.length > 0) {
              item.groups.forEach((group) => {
                obj.groups.push(group);
                if (group.questions.length > 0) {
                  group.questions.forEach((question) => {
                    obj.questions.push(question);
                  });
                }
              });
            }
            this.allQuestionnaires.unshift(obj);
          });
          this.formShow = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    userDetails() {
      axiosIns
        .get(`user/${this.userData.id}`)
        .then((res) => {
          this.userData = res.data;
          this.reviewData.observer = this.userData.fullName;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getObservers() {
      this.observers = [];
      axiosIns
        .get(`existingObservers`)
        .then((res) => {
          this.observers = res.data.data;
          // this.reviewData.observer = this.userData.fullName;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setWorkingTime(timeType) {
      this.reviewData.workingTime = timeType;
      this.updateTimeConfigs(timeType);

      // AM/PM sadece başlangıç saatini kısıtlar; bitiş saati öğleni aşabilir
      if (timeType === "am") {
        // AM: başlangıç 00:00 - 11:55 aralığında olmalı
        if (!this.reviewData.startTime || this.reviewData.startTime >= "12:00") {
          this.reviewData.startTime = "08:00";
        }
        if (!this.reviewData.endTime) {
          this.reviewData.endTime = "12:00";
        }
      } else {
        // PM: başlangıç 12:00 - 23:55 aralığında olmalı
        if (!this.reviewData.startTime || this.reviewData.startTime < "12:00") {
          this.reviewData.startTime = "13:00";
        }
        if (!this.reviewData.endTime) {
          this.reviewData.endTime = "17:00";
        }
      }

      // Başlangıç değiştiyse bitişin hâlâ sonrasında olduğundan emin ol
      this.onStartTimeChange();
    },
    updateTimeConfigs(timeType) {
      // AM/PM sadece başlangıç saatini kısıtlar; bitiş saati serbesttir
      if (timeType === "am") {
        // AM: başlangıç sabah saatlerinde (00:00 - 11:55)
        this.startTimeConfig = {
          ...this.startTimeConfig,
          defaultHour: 8,
          defaultMinute: 0,
          minTime: "00:00",
          maxTime: "11:55",
        };
        this.endTimeConfig = {
          ...this.endTimeConfig,
          defaultHour: 12,
          defaultMinute: 0,
          minTime: "00:00",
          maxTime: "23:55",
        };
      } else {
        // PM: başlangıç öğleden sonra saatlerinde (12:00 - 23:55)
        this.startTimeConfig = {
          ...this.startTimeConfig,
          defaultHour: 13,
          defaultMinute: 0,
          minTime: "12:00",
          maxTime: "23:55",
        };
        this.endTimeConfig = {
          ...this.endTimeConfig,
          defaultHour: 17,
          defaultMinute: 0,
          minTime: "00:00",
          maxTime: "23:55",
        };
      }
    },
    onStartTimeChange() {
      // Start time end time'ı geçtiyse end time'ı otomatik ileri al
      this.reviewData.endTime = bumpEndTime(
        this.reviewData.startTime,
        this.reviewData.endTime
      );
    },
    onEndTimeChange() {
      // End time değiştiğinde start time'ı kontrol et
      if (this.reviewData.startTime && this.reviewData.endTime) {
        if (this.reviewData.endTime <= this.reviewData.startTime) {
          // End time start time'dan küçük veya eşitse, end time'ı otomatik ayarla (yukarı çıkar)
          const startHour = parseInt(this.reviewData.startTime.split(":")[0]);
          const startMinute = parseInt(this.reviewData.startTime.split(":")[1]);

          let newEndHour = startHour;
          let newEndMinute = startMinute + 5; // 5 dakika ekle

          if (newEndMinute >= 60) {
            newEndHour += 1;
            newEndMinute = 0;
          }

          // Bitiş saati öğleni aşabilir; sadece gün sonu sınırı uygulanır
          const maxHour = 23;
          const maxMinute = 55;

          if (
            newEndHour > maxHour ||
            (newEndHour === maxHour && newEndMinute > maxMinute)
          ) {
            newEndHour = maxHour;
            newEndMinute = maxMinute;
          }

          this.reviewData.endTime = `${newEndHour
            .toString()
            .padStart(2, "0")}:${newEndMinute.toString().padStart(2, "0")}`;
        }
      }
    },
    formSubmitted() {
      this.formShow = true;
      const self = this;
      this.$refs.reviewRules.validate().then((success) => {
        if (success) {
          if (
            self.reviewData.selectedTask != null &&
            (self.reviewData.surveyDate == null ||
              self.reviewData.startTime == null ||
              self.reviewData.endTime == null)
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                text: "Please fill in the Review Date and Working Time",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });

            this.formShow = false;

            return;
          }
          if (
            !isValidTimeRange(self.reviewData.startTime, self.reviewData.endTime)
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                text: INVALID_TIME_RANGE_MESSAGE,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            this.formShow = false;
            return;
          }
          self.reviewData.event.groups.forEach((group) => {
            group.questions.forEach((question) => {
              self.reviewData.questionAnswer.forEach((answer) => {
                if (answer.questionId == question.id) {
                  answer.surveyId = self.reviewData.event.id;
                  answer.status = question.status;
                }
              });
            });
          });

          // Convert date to backend format (MM-DD-YYYY) before sending
          const reviewDataToSend = { ...this.reviewData };
          if (reviewDataToSend.surveyDate) {
            reviewDataToSend.surveyDate = this.convertDateToBackend(
              reviewDataToSend.surveyDate
            );
          }

          store
            .dispatch("review/addNewReview", reviewDataToSend)
            .then((res) => {
              this.toastMessage("Review");
              if (
                self.reviewData.event &&
                self.reviewData.event.follow_up_config &&
                self.reviewData.event.follow_up_config.enabled
              ) {
                self.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Follow-ups Scheduled',
                    text: 'Follow-up reviews have been automatically scheduled based on this review.',
                    icon: 'CalendarIcon',
                    variant: 'success',
                  },
                });
              }
              setTimeout(function() {
                self.formShow = false;
                router.push({ name: "review-list" });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  text: apiErrorMessage(error, "Review could not be saved."),
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              this.formShow = false;
            });
        } else {
          this.formShow = false;
        }
      });
    },
    toastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successful",
          text: "✔️ " + val + " Add Successful",
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    generateScoreRange(item) {
      const options = ["Not Observed"];

      if (item.maxScore) {
        for (let i = 0; i <= item.maxScore; i++) {
          options.push(i.toString());
        }
      }

      return options;
    },

    selectedPersonHandler(person) {
      if (person) {
        this.reviewData.firstName = person.name;
        this.reviewData.lastName = person.surname;
        this.reviewData.emailAdress = person.email;
        this.reviewData.reviewee = person.fullName; // Reviewee bilgisini ekliyoruz

        this.reviewData.event = null;
        this.groups = [];
        this.eventTypes = [];
        this.allQuestionnaires.forEach((q) => {
          this.eventTypes.push(q);
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#eventLabel__BV_label_ {
  text-decoration: underline;
}

.animate__animated.animate__fadeIn {
  --animate-duration: 3s;
}

/* V-Select dropdown text truncation */
.vs__dropdown-option {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.vs__selected {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: calc(100% - 20px) !important;
}

/* Fix for v-select dropdown menu items */
.vs__dropdown-menu {
  max-width: 100% !important;
}

.vs__dropdown-option div {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

/* Fix for selected option in the input */
#event .vs__selected {
  max-width: calc(100% - 30px) !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Table dropdown fix for z-index and overflow */
.table {
  overflow: visible !important;

  /* Time select styling */
  .vs__dropdown-toggle {
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    min-height: 38px;
    padding: 0.571rem 0.857rem;
  }

  .vs__selected {
    font-size: 1rem;
    color: #6e6b7b;
  }

  td,
  th {
    overflow: visible !important;
    position: relative;
  }

  /* Table wrapper should also allow overflow */
  .table-responsive {
    overflow: visible !important;
  }
}

/* V-Select in table cells - fix z-index issues */
.table .vs__dropdown-toggle {
  position: relative;
  z-index: 10;
}

.table .vs__dropdown-menu {
  position: absolute !important;
  z-index: 1000 !important;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #ddd;
  background: white;
}

/* Ensure table cells containing dropdowns can overflow */
.table td:has(.v-select),
.table th:has(.v-select) {
  overflow: visible !important;
  position: relative;
}

/* Fix for Bootstrap table responsive wrapper */
.table-responsive {
  overflow: visible !important;
}

/* Group Section Styling */
.group-section {
  border: 1px solid #e3e6f0;
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: visible !important; /* Allow dropdowns to overflow */

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }

  /* Ensure table within group section allows overflow */
  .table-responsive {
    overflow: visible !important;
  }

  .table {
    overflow: visible !important;

    td,
    th {
      overflow: visible !important;
    }
  }
}

.group-title {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  color: #003b49 !important;
  border-bottom: 2px solid #003b49;
  padding-bottom: 0.5rem;
}
</style>
